module.exports = require('../../../shared/affiliateEpi.js');
